var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "40px 80px" } },
    [
      _c("div", [
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticClass: "block_representation" }),
          _vm._v(" "),
          _c("div", { staticClass: "block_title" }, [
            _vm._v("基础信息" + _vm._s(_vm.memberId)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "message_box" }, [
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("用户ID:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.userId)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [_vm._v("手机号码:")]),
              _vm._v(" "),
              _vm.details
                ? _c("span", { staticClass: "span2" }, [
                    _vm._v(" " + _vm._s(_vm.dataObj.phone)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "editor_box fc pointer",
                  on: {
                    click: function ($event) {
                      return _vm.onEditPhone(_vm.dataObj.phone)
                    },
                  },
                },
                [_vm._v("\n            编辑\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("用户昵称:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.nickname)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("真实姓名:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.realName || _vm.Fill)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("是否有效会员：")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.effective ? "是" : "否")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [_vm._v("用户身份：")]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm.dataObj.identity === 0
                  ? _c("span", [_vm._v("自购用户")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataObj.identity === 1
                  ? _c("span", [_vm._v("团队代理")])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "editor_box fc pointer",
                  on: {
                    click: function ($event) {
                      return _vm.onEditArea(_vm.dataObj.identity)
                    },
                  },
                },
                [_vm._v("\n            编辑\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("用户状态:")]),
            _vm._v(" "),
            _vm.dataObj.blacklist
              ? _c("span", { staticClass: "span2" }, [_vm._v(" 拉黑")])
              : _vm._e(),
            _vm._v(" "),
            _vm.dataObj.disable
              ? _c("span", { staticClass: "span2" }, [_vm._v(" 失效")])
              : _vm._e(),
            _vm._v(" "),
            _vm.dataObj.locked
              ? _c("span", { staticClass: "span2" }, [_vm._v(" 锁定")])
              : _vm._e(),
            _vm._v(" "),
            _vm.dataObj.logoff
              ? _c("span", { staticClass: "span2" }, [_vm._v(" 注销")])
              : _vm._e(),
            _vm._v(" "),
            _vm.dataObj.logoff
              ? _c(
                  "span",
                  {
                    staticClass: "pointer",
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "12px",
                      color: "#4d8aff",
                      border: "1px solid #4d8aff",
                      padding: "6px 10px",
                      "border-radius": "4px",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onCancellation(_vm.dataObj.userId)
                      },
                    },
                  },
                  [_vm._v("撤销注销")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.dataObj.blacklist &&
            !_vm.dataObj.disable &&
            !_vm.dataObj.locked &&
            !_vm.dataObj.logoff
              ? _c("span", { staticClass: "span2" }, [
                  _vm._v("\n          正常"),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("注册时间:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.registerTime)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("系统邀请码：")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.systemInviteCode)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [_vm._v("用户等级:")]),
              _vm._v(" "),
              _vm.details
                ? _c("span", { staticClass: "span2" }, [
                    _vm._v(" " + _vm._s(_vm.details.gradeName)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "editor_box fc pointer",
                  on: {
                    click: function ($event) {
                      return _vm.onEditPurchaseGrade(_vm.details.selfGrade)
                    },
                  },
                },
                [_vm._v("\n            编辑\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [_vm._v("等级到期时间:")]),
              _vm._v(" "),
              _vm.dataObj.detail
                ? _c("span", { staticClass: "span2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.dataObj.detail.gradeInvalidTime ===
                            "2099-12-31 23:59:59"
                            ? "永久"
                            : _vm.dataObj.detail.gradeInvalidTime || "永久"
                        ) +
                        "\n          "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.dataObj.detail &&
            _vm.dataObj.detail.gradeInvalidTime &&
            _vm.dataObj.detail.gradeInvalidTime != "2099-12-31 23:59:59"
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "editor_box fc pointer",
                      on: {
                        click: function ($event) {
                          return _vm.onEditTime(
                            _vm.dataObj.detail.gradeInvalidTime
                          )
                        },
                      },
                    },
                    [_vm._v("\n            编辑\n          ")]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("等级变更时间:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.editGradeTime || _vm.Fill)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [_vm._v("自定义邀请码：")]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm._v(" " + _vm._s(_vm.details.defineInviteCode || _vm.Fill)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "editor_box fc pointer",
                  on: {
                    click: function ($event) {
                      return _vm.onEditCode(_vm.details.defineInviteCode)
                    },
                  },
                },
                [_vm._v("\n            编辑\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "template1 flex frb ",
              staticStyle: { width: "750px" },
            },
            [
              _c("div", { staticClass: "flex" }, [
                _c("span", { staticClass: "span1" }, [_vm._v("会员标签:")]),
                _vm._v(" "),
                _vm.details
                  ? _c(
                      "span",
                      {
                        staticClass: "span2 ellipsis-multiline1",
                        staticStyle: { width: "500px" },
                      },
                      _vm._l(_vm.hasLabels, function (item, index) {
                        return _c(
                          "span",
                          { key: index, staticClass: "ml10 labels_style" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.labelName) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "editor_box fc pointer",
                    on: {
                      click: function ($event) {
                        return _vm.onEditLabel(_vm.dataObj.remark)
                      },
                    },
                  },
                  [_vm._v("\n            编辑\n          ")]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("用户最近使用时间:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.loginTime)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "template1 flex frb",
              staticStyle: { width: "750px" },
            },
            [
              _c("div", { staticClass: "flex" }, [
                _c("span", { staticClass: "span1" }, [_vm._v("用户备注:")]),
                _vm._v(" "),
                _vm.details
                  ? _c("span", { staticClass: "span2 ellipsis-multiline1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.dataObj.remark || _vm.Fill)
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "editor_box fc pointer",
                    on: {
                      click: function ($event) {
                        return _vm.onEditRemark(_vm.dataObj.remark)
                      },
                    },
                  },
                  [_vm._v("\n            编辑\n          ")]
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "message_box" }, [
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("是否绑定微信：")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.bindWechat ? "是" : "否")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("用户的联系QQ号：")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.qq || "未设置")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [
              _vm._v("用户的联系微信号："),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.wechat || "未设置")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("直邀请粉丝数：")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.fansCount)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [
                _vm._v("淘宝是否已授权："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm._v(_vm._s(_vm.details.tbAuth ? "是" : "否")),
              ]),
            ]),
            _vm._v(" "),
            _vm.details.tbAuth
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "editor_box fc pointer",
                      on: { click: _vm.onUntieTB },
                    },
                    [_vm._v("取消授权")]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("淘宝id:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.tbRelationId || _vm.Fill)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("淘宝昵称:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.tbRelationName || _vm.Fill)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [_vm._v("自购账户余额：")]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.selfBalance) + "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "editor_box fc pointer",
                  on: {
                    click: function ($event) {
                      return _vm.onDetail(_vm.dataObj.userId, "self")
                    },
                  },
                },
                [_vm._v("\n            明细\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [
                _vm._v("拼多多是否已授权："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm._v(" " + _vm._s(_vm.details.pddAuth ? "是" : "否")),
              ]),
            ]),
            _vm._v(" "),
            _vm.details.pddAuth
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "editor_box fc pointer",
                      on: { click: _vm.onUntiePDD },
                    },
                    [_vm._v("\n            取消授权\n          ")]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("拼多多id:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.details.pddRelationId || _vm.Fill)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [
              _vm._v("拼多多最后下单时间:"),
            ]),
            _vm._v(" "),
            _vm.details
              ? _c("span", { staticClass: "span2" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.details.lastPddTime || _vm.Fill)
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [_vm._v("团队账户余额：")]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.teamBalance) + "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "editor_box fc pointer",
                  on: {
                    click: function ($event) {
                      return _vm.onDetail(_vm.dataObj.userId, "team")
                    },
                  },
                },
                [_vm._v("\n            明细\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1 flex frb" }, [
            _c("div", [
              _c("span", { staticClass: "span1" }, [
                _vm._v("唯品会是否已授权："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm._v(" " + _vm._s(_vm.details.wphAuth ? "是" : "否")),
              ]),
            ]),
            _vm._v(" "),
            _vm.details.wphAuth
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "editor_box fc pointer",
                      on: { click: _vm.onUntieWPH },
                    },
                    [_vm._v("\n            取消授权\n          ")]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm.dataObj.inviter
          ? _c("div", { staticClass: "message_box" }, [
              _c("div", { staticClass: "template1" }, [
                _c("span", { staticClass: "span1" }, [_vm._v("邀请人用户ID:")]),
                _vm._v(" "),
                _c("span", { staticClass: "span2" }, [
                  _vm._v(" " + _vm._s(_vm.dataObj.inviter.userId || null)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "template1" }, [
                _c("span", { staticClass: "span1" }, [_vm._v("邀请人昵称:")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "pointer",
                    staticStyle: { "font-size": "16px", color: "#4d8aff" },
                    on: {
                      click: function ($event) {
                        return _vm.onUserDetails(
                          _vm.dataObj.inviter.userId,
                          _vm.dataObj.inviter.nickname
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.dataObj.inviter.nickname))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "template1" }, [
                _c("span", { staticClass: "span1" }, [
                  _vm._v("邀请人直属上级ID:"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "span2" }, [
                  _vm._v(" " + _vm._s(_vm.dataObj.inviter.superId || null)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "template1" }, [
                _c("span", { staticClass: "span1" }, [
                  _vm._v("邀请人直属上级昵称:"),
                ]),
                _vm._v(" "),
                _vm.dataObj.inviter
                  ? _c(
                      "span",
                      {
                        staticClass: "span2 pointer",
                        staticStyle: { color: "#4d8aff" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserDetails(
                              _vm.dataObj.inviter.superId,
                              _vm.dataObj.inviter.superName
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.dataObj.inviter.superName)
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "message_box" }, [
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("注册区域:")]),
            _vm._v(" "),
            _vm.dataObj.registerRegion
              ? _c("span", { staticClass: "span2" }, [
                  _vm._v("\n          " + _vm._s(_vm.dataObj.registerRegion)),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "template1 flex frb",
              staticStyle: { "min-width": "750px", width: "fit-content" },
            },
            [
              _c("div", { staticClass: "flex" }, [
                _c("span", { staticClass: "span1 mr10" }, [
                  _vm._v("区代设置:"),
                ]),
                _vm._v(" "),
                _vm.dataObj.region.type === 0
                  ? _c("span", { staticClass: "span2" }, [
                      _vm._v(
                        "\n            区域代理-" +
                          _vm._s(_vm.regionDataList.agentFullName)
                      ),
                    ])
                  : _vm.dataObj.region.type === 1
                  ? _c("span", { staticClass: "span2" }, [
                      _vm._v("\n            区域总代理"),
                    ])
                  : _c("span", [_vm._v("-")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ml10" }, [
                _c(
                  "div",
                  {
                    staticClass: "editor_box fc pointer",
                    on: { click: _vm.onEditRegional },
                  },
                  [_vm._v("\n            编辑\n          ")]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.dataObj.region.type === 0
            ? _c("div", { staticClass: "template1 flex frb" }, [
                _c("div", { staticClass: "flex" }, [
                  _c("span", { staticClass: "span1" }, [_vm._v("绑定的总代:")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "span2",
                      staticStyle: { color: "#4d8aff", cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.onUserDetails(
                            _vm.regionDataList.generalAgent.memberId,
                            _vm.regionDataList.generalAgent.nickname
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.regionDataList.generalAgentPhone)
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dataObj.region.type === 1
            ? _c(
                "div",
                {
                  staticClass: "template1 flex frb",
                  staticStyle: { "min-width": "370px", width: "fit-content" },
                },
                [
                  _c("div", { staticClass: "flex" }, [
                    _c("span", { staticClass: "span1" }, [
                      _vm._v("绑定的区代:"),
                    ]),
                    _vm._v(" "),
                    _vm.regionDataList.agentMappings.length > 0
                      ? _c(
                          "span",
                          { staticClass: "span2 ml10" },
                          _vm._l(
                            _vm.regionDataList.agentMappings,
                            function (item, index) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUserDetails(
                                        item.memberId,
                                        item.nickname
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#4d8aff",
                                        cursor: "pointer",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.phone))]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml8" }, [
                                    _vm._v("/"),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "message_box" }, [
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("App版本号:")]),
            _vm._v(" "),
            _c("span", { staticClass: "span2" }, [
              _vm._v(" " + _vm._s(_vm.dataObj.appVersion)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "template1", staticStyle: { width: "750px" } },
            [
              _c("span", { staticClass: "span1" }, [
                _vm._v("最后登录手机信息:"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "span2" }, [
                _vm._v(" " + _vm._s(_vm.dataObj.clientInfo)),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "message_box" }, [
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("淘宝:")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "span2" },
              [
                [
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.tbLimit,
                        label: true,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("tb", true)
                        },
                      },
                    },
                    [_vm._v("允许")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.tbLimit,
                        label: false,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("tb", false)
                        },
                      },
                    },
                    [_vm._v("禁止")]
                  ),
                ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("京东:")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "span2" },
              [
                [
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.jdLimit,
                        label: true,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("jd", true)
                        },
                      },
                    },
                    [_vm._v("允许")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.jdLimit,
                        label: false,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("jd", false)
                        },
                      },
                    },
                    [_vm._v("禁止")]
                  ),
                ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("拼多多:")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "span2" },
              [
                [
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.pddLimit,
                        label: true,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("pdd", true)
                        },
                      },
                    },
                    [_vm._v("允许")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.pddLimit,
                        label: false,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("pdd", false)
                        },
                      },
                    },
                    [_vm._v("禁止")]
                  ),
                ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("唯品会:")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "span2" },
              [
                [
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.wphLimit,
                        label: true,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("wph", true)
                        },
                      },
                    },
                    [_vm._v("允许")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.wphLimit,
                        label: false,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("wph", false)
                        },
                      },
                    },
                    [_vm._v("禁止")]
                  ),
                ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template1" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("抖音:")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "span2" },
              [
                [
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.dyLimit,
                        label: true,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("dy", true)
                        },
                      },
                    },
                    [_vm._v("允许")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: {
                        value: _vm.memberChainLimitVo.dyLimit,
                        label: false,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeLimit("dy", false)
                        },
                      },
                    },
                    [_vm._v("禁止")]
                  ),
                ],
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        false
          ? _c("div", { staticClass: "flex mt30 fai" }, [
              _c("div", { staticClass: "block_representation" }),
              _vm._v(" "),
              _c("div", { staticClass: "block_title" }, [
                _vm._v("是否设置为推广客"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml10" },
                [
                  _c("el-switch", {
                    attrs: {
                      value: _vm.dataObj.promotion,
                      "active-color": "#4D8AFF",
                      "inactive-color": "#B7B7B7",
                    },
                    on: { change: _vm.onChangeSwitch },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fw", staticStyle: { "margin-top": "20px" } },
          [
            !_vm.dataObj.disable
              ? _c(
                  "div",
                  {
                    staticClass: "btn_box fc pointer",
                    on: { click: _vm.onLoseEffectivenessUser },
                  },
                  [
                    _vm._v("\n        失效当前用户\n        "),
                    _c("TipsPopup", { attrs: { type: "loseEffectiveness" } }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataObj.disable
              ? _c(
                  "div",
                  { staticClass: "btn_box fc pointer Prohibited_btn" },
                  [
                    _vm._v("\n        当前用户已失效\n        "),
                    _c("TipsPopup", { attrs: { type: "loseEffectiveness" } }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.dataObj.locked
              ? _c(
                  "div",
                  {
                    staticClass: "btn_box fc pointer",
                    on: { click: _vm.onLockUser },
                  },
                  [
                    _vm._v("\n        禁止提现\n        "),
                    _c("TipsPopup", { attrs: { type: "prohibit" } }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataObj.locked
              ? _c(
                  "div",
                  {
                    staticClass: "btn_box fc pointer Prohibited_btn",
                    on: { click: _vm.onUnlockUser },
                  },
                  [
                    _vm._v("\n        允许提现\n        "),
                    _c("TipsPopup", { attrs: { type: "prohibit" } }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.dataObj.blacklist
              ? _c(
                  "div",
                  {
                    staticClass: "btn_box fc pointer",
                    on: { click: _vm.onJoinBlacklist },
                  },
                  [
                    _vm._v("\n        加入黑名单\n        "),
                    _c("TipsPopup", { attrs: { type: "Blacklist" } }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataObj.blacklist
              ? _c(
                  "div",
                  {
                    staticClass: "btn_box fc pointer Prohibited_btn",
                    on: { click: _vm.onCancelBlacklist },
                  },
                  [
                    _vm._v("\n        取消黑名单\n        "),
                    _c("TipsPopup", { attrs: { type: "Blacklist" } }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn_box fc pointer" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "issue_deduction_btn",
                    attrs: { slot: "reference", type: "text" },
                    on: {
                      click: function ($event) {
                        _vm.visibles = !_vm.visibles
                      },
                    },
                    slot: "reference",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc",
                        staticStyle: { "font-size": "16px" },
                      },
                      [
                        _vm._v("\n            余额发放/扣除\n            "),
                        _c("TipsPopup", { attrs: { type: "IssueDeduction" } }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn_box fc pointer",
                on: { click: _vm.onBonusPaymentRecords },
              },
              [_vm._v("\n        余额发放/扣除明细\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn_box fc pointer",
                on: { click: _vm.onChangeLog },
              },
              [_vm._v("\n        用户信息变更记录\n      ")]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editData.type === 1 ? "修改自购等级" : "修改邀请码",
            visible: _vm.dialogVisible,
            width: "850px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c("div", { staticClass: "fc" }, [
            _c("div", [
              _vm.editData.type === 1
                ? _c("div", { staticClass: "flex" }, [
                    _c("div", { staticClass: "fc" }, [
                      _c("span", { staticClass: "text_box" }, [
                        _vm._v("修改等级"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ml20", staticStyle: { width: "600px" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "600px" },
                            attrs: { placeholder: "请选择" },
                            on: { change: _vm.changeEditDataVal },
                            model: {
                              value: _vm.editData.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "value", $$v)
                              },
                              expression: "editData.value",
                            },
                          },
                          _vm._l(_vm.editOptions, function (item) {
                            return _c("el-option", {
                              key: item.grade,
                              attrs: { label: item.name, value: item.grade },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.editData.type === 1
                ? _c("div", { staticClass: "flex mt20" }, [
                    _c("div", { staticClass: "fc" }, [
                      _c("span", { staticClass: "text_box" }, [_vm._v("时长")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ml20", staticStyle: { width: "600px" } },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "0",
                              disabled: _vm.editData.value <= _vm.MinimumLevel,
                            },
                            model: {
                              value: _vm.editData.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "duration", $$v)
                              },
                              expression: "editData.duration",
                            },
                          },
                          [_vm._v("7天")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "1",
                              disabled: _vm.editData.value <= _vm.MinimumLevel,
                            },
                            model: {
                              value: _vm.editData.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "duration", $$v)
                              },
                              expression: "editData.duration",
                            },
                          },
                          [_vm._v("14天")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "2",
                              disabled: _vm.editData.value <= _vm.MinimumLevel,
                            },
                            model: {
                              value: _vm.editData.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "duration", $$v)
                              },
                              expression: "editData.duration",
                            },
                          },
                          [_vm._v("1个月")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "3",
                              disabled: _vm.editData.value <= _vm.MinimumLevel,
                            },
                            model: {
                              value: _vm.editData.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "duration", $$v)
                              },
                              expression: "editData.duration",
                            },
                          },
                          [_vm._v("3个月")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "4",
                              disabled: _vm.editData.value <= _vm.MinimumLevel,
                            },
                            model: {
                              value: _vm.editData.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "duration", $$v)
                              },
                              expression: "editData.duration",
                            },
                          },
                          [_vm._v("6个月")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              label: "5",
                              disabled: _vm.editData.value <= _vm.MinimumLevel,
                            },
                            model: {
                              value: _vm.editData.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "duration", $$v)
                              },
                              expression: "editData.duration",
                            },
                          },
                          [_vm._v("1年")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "6" },
                            model: {
                              value: _vm.editData.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.editData, "duration", $$v)
                              },
                              expression: "editData.duration",
                            },
                          },
                          [_vm._v("永久")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.editData.type === 2
                ? _c("div", { staticClass: "flex" }, [
                    _c("div", { staticClass: "fc" }, [
                      _c("span", { staticClass: "text_box" }, [
                        _vm._v("修改邀请码"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ml20", staticStyle: { width: "600px" } },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "6",
                            minlength: "6",
                            placeholder: "请输入邀请码",
                          },
                          model: {
                            value: _vm.editData.value,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.editData,
                                "value",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "editData.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "flex mt20" }, [
                _c("div", { staticClass: "fc" }, [
                  _c("span", { staticClass: "text_box" }, [_vm._v("修改原因")]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "ml20", staticStyle: { width: "600px" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入原因" },
                        model: {
                          value: _vm.editData.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.editData, "remark", $$v)
                          },
                          expression: "editData.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex " }, [
                _c("div", { staticClass: "fc" }, [
                  _c("span", { staticClass: "text_box" }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticStyle: { width: "600px" } }, [
                    _vm.editData.type === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "ml20 mt10",
                            staticStyle: {
                              "font-size": "14px",
                              color: "#f59a23",
                              "font-weight": "400",
                            },
                          },
                          [
                            _vm._v(
                              "当修改用户等级并确认有效时长时，用户等级的到期时间会重新计算"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc mt20" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onVerify } },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.untieDialog,
            width: "650px",
            "before-close": _vm.untieClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "fc",
              staticStyle: {
                "font-weight": "600",
                "font-size": "18px",
                color: "#474245",
              },
            },
            [
              _vm._v(
                "\n      是否确定要解绑" +
                  _vm._s(_vm.platformName[_vm.platform]) +
                  "授权？\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc mt30" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onUntieVerify },
                },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.untieClose } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.areaData,
            width: "650px",
            "before-close": _vm.areaHandleClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "fc" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-position": "left",
                    "label-width": "125px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "请选择用户类型:" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.targetIdentity,
                            callback: function ($$v) {
                              _vm.targetIdentity = $$v
                            },
                            expression: "targetIdentity",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("自购用户"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("团队代理"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc mt20" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAreaVerify } },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.areaHandleClose } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.regionalSetting,
            "before-close": _vm.regionalClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "800px" } },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "right", "label-width": "150px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "请选择区域代理类型:" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.regionDataList.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.regionDataList, "type", $$v)
                            },
                            expression: "regionDataList.type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("区域代理"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("区域总代理"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.regionDataList.type === 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "添加区域:" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "138px" },
                              attrs: { placeholder: "请选择省" },
                              on: { change: _vm.getCity },
                              model: {
                                value: _vm.regionDataList.firstRegionCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.regionDataList,
                                    "firstRegionCode",
                                    $$v
                                  )
                                },
                                expression: "regionDataList.firstRegionCode",
                              },
                            },
                            _vm._l(
                              _vm.regionDataList.firstRegionCodeData,
                              function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.regionName,
                                    value: item.regionCode,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "138px" },
                              attrs: { placeholder: "请选择市" },
                              on: { change: _vm.getRegion },
                              model: {
                                value: _vm.regionDataList.secondRegionCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.regionDataList,
                                    "secondRegionCode",
                                    $$v
                                  )
                                },
                                expression: "regionDataList.secondRegionCode",
                              },
                            },
                            _vm._l(
                              _vm.regionDataList.secondRegionCodeData,
                              function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.regionName,
                                    value: item.regionCode,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "138px" },
                              attrs: { placeholder: "请选择区" },
                              on: { change: _vm.getArea },
                              model: {
                                value: _vm.regionDataList.thirdRegionCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.regionDataList,
                                    "thirdRegionCode",
                                    $$v
                                  )
                                },
                                expression: "regionDataList.thirdRegionCode",
                              },
                            },
                            _vm._l(
                              _vm.regionDataList.thirdRegionCodeData,
                              function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.regionName,
                                    value: item.regionCode,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.regionDataList.type === 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "是否要绑定总代:" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.isAll,
                                    callback: function ($$v) {
                                      _vm.isAll = $$v
                                    },
                                    expression: "isAll",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("不绑定"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("绑定"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isAll === 1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: " " } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "350px" },
                                    attrs: { placeholder: "请输入手机号码" },
                                    model: {
                                      value:
                                        _vm.regionDataList.generalAgentPhone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.regionDataList,
                                          "generalAgentPhone",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "regionDataList.generalAgentPhone",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc mt20" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onUpdateUserRegion },
                },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.onCancelRegion } }, [
                _vm._v("取消总代/区代身份"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isRemark,
            width: "650px",
            title: "编辑备注",
            "before-close": _vm.RemarkClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c(
            "div",
            [
              _c("el-input", {
                attrs: {
                  placeholder: "",
                  type: "textarea",
                  rows: 6,
                  "show-word-limit": "",
                  maxlength: "50",
                },
                model: {
                  value: _vm.remarkVal,
                  callback: function ($$v) {
                    _vm.remarkVal = $$v
                  },
                  expression: "remarkVal",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc mt30" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onRemarkVerify },
                },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.RemarkClose } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isPhone,
            width: "650px",
            title: "编辑手机号",
            "before-close": _vm.phoneClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm1",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm1,
                    rules: _vm.rules1,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "输入新手机号", prop: "targetPhone" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "11" },
                        model: {
                          value: _vm.ruleForm1.targetPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "targetPhone", $$v)
                          },
                          expression: "ruleForm1.targetPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "修改原因", prop: "reason" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm1.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "reason", $$v)
                          },
                          expression: "ruleForm1.reason",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm1("ruleForm1")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm1("ruleForm1")
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isLabel,
            width: "650px",
            title: "编辑用户标签",
            "before-close": _vm.LabelClose,
            "close-on-click-modal": false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex", staticStyle: { width: "100%" } },
            [
              _c("span", { staticClass: "span1 fc" }, [
                _vm._v("设置用户标签:"),
              ]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "500px" },
                  attrs: {
                    "popper-class": "select-box",
                    multiple: "",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    placeholder: "请选择用户标签",
                  },
                  model: {
                    value: _vm.labValue,
                    callback: function ($$v) {
                      _vm.labValue = $$v
                    },
                    expression: "labValue",
                  },
                },
                _vm._l(_vm.allLabels, function (item) {
                  return _c("el-option", {
                    key: item.labelName,
                    attrs: { label: item.labelName, value: item.labelName },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc mt30" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onLabelVerify },
                },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.LabelClose } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "余额发放/扣除",
            visible: _vm.visibles,
            width: "850px",
            "before-close": _vm.handleCloseVisibles,
            "close-on-click-modal": false,
          },
        },
        [
          _c("div", { staticClass: "fc" }, [
            _c(
              "div",
              {
                staticClass: "issue_deduction",
                staticStyle: { width: "600px" },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "业务类型", prop: "region" } },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "in" },
                            model: {
                              value: _vm.ruleForm.region,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "region", $$v)
                              },
                              expression: "ruleForm.region",
                            },
                          },
                          [_vm._v("余额充值")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "out" },
                            model: {
                              value: _vm.ruleForm.region,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "region", $$v)
                              },
                              expression: "ruleForm.region",
                            },
                          },
                          [_vm._v("余额扣除")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "账户类型", prop: "accountType" } },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "self" },
                            model: {
                              value: _vm.ruleForm.accountType,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "accountType", $$v)
                              },
                              expression: "ruleForm.accountType",
                            },
                          },
                          [_vm._v("自购账户")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "team" },
                            model: {
                              value: _vm.ruleForm.accountType,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "accountType", $$v)
                              },
                              expression: "ruleForm.accountType",
                            },
                          },
                          [_vm._v("团队账户")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "操作金额", prop: "money" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入金额", clearable: "" },
                          on: { input: _vm.onMoneyInput },
                          model: {
                            value: _vm.ruleForm.money,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "money", _vm._n($$v))
                            },
                            expression: "ruleForm.money",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "操作原因", prop: "reson" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: "",
                            placeholder: "请输入内容",
                          },
                          model: {
                            value: _vm.ruleForm.reson,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "reson", $$v)
                            },
                            expression: "ruleForm.reson",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.resetForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("AccountDetails", { ref: "accountDetails" }),
      _vm._v(" "),
      _c("InformationChangePopup", {
        ref: "InformationChangePopup",
        attrs: { "log-type": _vm.logType },
      }),
      _vm._v(" "),
      _c("BonusPaymentRecordsPopupCopy", {
        ref: "BonusPaymentRecordsPopupCopy",
      }),
      _vm._v(" "),
      _c("MaturityDate", {
        ref: "maturityDate",
        on: { timeRefresh: _vm.onTimeRefresh },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mt30" }, [
      _c("div", { staticClass: "block_representation" }),
      _vm._v(" "),
      _c("div", { staticClass: "block_title" }, [_vm._v("扩展信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mt30" }, [
      _c("div", { staticClass: "block_representation" }),
      _vm._v(" "),
      _c("div", { staticClass: "block_title" }, [_vm._v("邀请人信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mt30" }, [
      _c("div", { staticClass: "block_representation" }),
      _vm._v(" "),
      _c("div", { staticClass: "block_title" }, [_vm._v("用户区域信息：")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mt30" }, [
      _c("div", { staticClass: "block_representation" }),
      _vm._v(" "),
      _c("div", { staticClass: "block_title" }, [_vm._v("其他信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mt30" }, [
      _c("div", { staticClass: "block_representation" }),
      _vm._v(" "),
      _c("div", { staticClass: "block_title" }, [
        _vm._v("转链功能（禁止后该会员对应联盟无法转链）"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mt30" }, [
      _c("div", { staticClass: "block_representation" }),
      _vm._v(" "),
      _c("div", { staticClass: "block_title" }, [_vm._v("扩展功能")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }